import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import accouts from '../assets/images/accounts.png'
import easy from '../assets/images/easy.png'
import honda from '../assets/images/honda.png'
import hmbr from '../assets/images/hmbr.png'
import './Projects.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Projects = () => {
    useEffect(()=>{
        AOS.init({duration: 1500});
    },[]);

    return (
        <div className='w-11/12 lg:w-8/12 lg:mr-28 mx-auto bg-gray-600'>
            <h2 className='text-center text-3xl bg-gray-800 bg-opacity-80 p-2 w-full text-orange-400 font-serif uppercase font-bold mt-20'>My Projects</h2>
            <div className='grid grid-cols-1 lg:grid-cols-1 md:grid-cols-2 gap-5 shadow-lg rounded-lg mt-8'>

                <div data-aos='flip-left'  class="card lg:card-side bg-base-100 shadow-xl">
                    <figure className='flex flex-col'><img className='h-80 shadow-lg' src={accouts} alt="Album" />
                    <div className='my-auto'>
                        <button className='btn btn-xs btn-primary bg-opacity-75 rounded-xl my-2 mr-2'>React</button>
                        <button className='btn btn-xs btn-secondary bg-opacity-75 rounded-xl my-2 mr-2'>Node</button>
                        <button className='btn btn-xs btn-accent bg-opacity-75 rounded-xl my-2 mr-2'>Express</button>
                        <button className='btn btn-xs btn-neutral bg-opacity-75 rounded-xl my-2 mr-2'>MongoDB</button>
                        <button className='btn btn-xs btn-info bg-opacity-75 rounded-xl my-2 mr-2'>Tailwind</button>
                        <button className='btn btn-xs btn-success bg-opacity-75 rounded-xl my-2 mr-2'>Firebase</button>
                    </div>
                    </figure>
                   
                    <div class="card-body">
                        <h2 class="card-title">My Accounts (Accounting Software)</h2>
                        <p className='text-left'>● Expense and income-based Accounting Software. <br />
                            ● Users can view daily cash , bank deposits, and withdrawals. <br />
                            ● All expense and income-related reports</p>
                        <div class="card-actions justify-end">
                            <button class="btn text-orange-400 hover:text-white"><Link to='my-accounts'>View Details</Link></button>
                        </div>
                    </div>
                </div>
                <div data-aos='flip-right' class="card lg:card-side bg-base-100 shadow-xl">
                    <figure className='flex flex-col'><img className='h-80 shadow-lg' src={hmbr} alt="Album" />
                    <div className='my-auto'>
                        <button className='btn btn-xs btn-primary bg-opacity-75 rounded-xl my-2 mr-2'>React</button>
                        <button className='btn btn-xs btn-secondary bg-opacity-75 rounded-xl my-2 mr-2'>Node</button>
                        <button className='btn btn-xs btn-accent bg-opacity-75 rounded-xl my-2 mr-2'>Express</button>
                        <button className='btn btn-xs btn-neutral bg-opacity-75 rounded-xl my-2 mr-2'>MongoDB</button>
                        <button className='btn btn-xs btn-info bg-opacity-75 rounded-xl my-2 mr-2'>Tailwind</button>
                        <button className='btn btn-xs btn-success bg-opacity-75 rounded-xl my-2 mr-2'>Firebase</button>
                    </div>
                    </figure>
                    <div class="card-body">
                        <h2 class="card-title">HMBR International (Manufacturer Website)</h2>
                        <p className='text-left'>● Website for tools and hardware Manufacturer Company with an order processing system. <br />
                            ● Users can log in, Register, and Order an item, see their orders, and manage their profile. <br />
                            ● Admin can add and manage Products, Orders, Users, and Update order status.</p>
                        <div class="card-actions justify-end">
                            <button class="btn text-orange-400 hover:text-white"><Link to='hmbr-international'>View Details</Link></button>
                        </div>
                    </div>
                </div>
                <div data-aos='flip-up' class="card lg:card-side bg-base-100 shadow-xl">
                    <figure className='flex flex-col'><img className='h-80' src={honda} alt="Album" />
                    <div className='my-auto'>
                        <button className='btn btn-xs btn-primary bg-opacity-75 rounded-xl my-2 mr-2'>React</button>
                        <button className='btn btn-xs btn-secondary bg-opacity-75 rounded-xl my-2 mr-2'>Node</button>
                        <button className='btn btn-xs btn-accent bg-opacity-75 rounded-xl my-2 mr-2'>Express</button>
                        <button className='btn btn-xs btn-neutral bg-opacity-75 rounded-xl my-2 mr-2'>MongoDB</button>
                        <button className='btn btn-xs btn-info bg-opacity-75 rounded-xl my-2 mr-2'>Tailwind</button>
                        <button className='btn btn-xs btn-success bg-opacity-75 rounded-xl my-2 mr-2'>Firebase</button>
                    </div>
                    </figure>
                    <div class="card-body">
                        <h2 class="card-title">NBC Motors (Honda Showroom Website)</h2>
                        <p className='text-left'>● A Honda Brand Motorcycle Shop Website with an inventory system. <br />
                            ● Only logged users can Update quantity Delete bikes, and Post a new sale. <br />
                            ● A normal customer can post a requirement for a Bike he wants.</p>
                        <div class="card-actions justify-end">
                            <button class="btn text-orange-400 hover:text-white"><Link to='nbc-motors'>View Details</Link></button>
                        </div>
                    </div>
                </div>

            </div>



        </div>
    );
};

export default Projects;